module.exports = __webpack_public_path__ + "img/arrow-down-blue.59a87306.svg";